export const DetailGrid = ({items}) => (
    <div className="admin-detail-grid">
        {items
            .filter((item) => item)
            .map((item) => (
                <div className="admin-detail-item" key={item.label}>
                    <p className="admin-detail-label">{item.label}</p>
                    <p className="admin-detail-value">{item.value ?? "—"}</p>
                </div>
            ))}
    </div>
);
